<template>
  <v-form ref="mainForm" v-model="valid">
    <template v-if="estSituation(1)">
      <opq-alert code="fichiers-etape-3-1"></opq-alert>
    </template>
    <template v-if="estSituation(2) || estSituation(3)">
      <opq-alert code="fichiers-etape-3-2"></opq-alert>
    </template>

    <data-iterator
      :list="sas.stagesInternats"
      add-new-text="Ajouter un stage"
      :live="{ endpoint: 'sas-equivalence-stages-internats', sasId: sas.id, payload: { codeTypePratique: '1' } }"
      :icon="$getIcon('formationPratique')"
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{}">
        <h3>Stage</h3>
      </template>
      <template v-slot:edit-mode="{ item }">
        <opq-file code="stage-attestation" :live="liveSasStagesInternats(7126, item)" :file="item.attestationStage"></opq-file>
      </template>
    </data-iterator>
  </v-form>
</template>

<script>
import FormHybrid from "@/mixins/FormHybrid"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormHybrid, CataloguesHelper],
  props: {
    sas: { type: Object }
  },
  methods: {
    liveSasStagesInternats(cle, item) {
      return { endpoint: "sas-equivalence-stages-internats", cle: cle, fileId: item.id }
    },
    estSituation(codeSituation) {
      return this.getCatalogueCodeById(7808, this.sas.sasNeuropsy.situation) == codeSituation
    }
  }
}
</script>

<style>
</style>